
import Todo from './comp/todo.jsx';
import './App.css';

function App() {
  return (
    <div>
      <Todo/>
    </div>
  );
}

export default App;
